import Head from 'next/head';
import React from 'react';
import { Box, Container } from '@mui/material';
import BaseLayout from 'layouts/BaseLayout';
import AdminList from 'components/Feedback/AdminList';
import { withAdmin } from 'hocs/withAdmin';

function FeedbacksAdminPage() {
  return (
    <BaseLayout hasPadding={false}>
      <Head>
        <title>Feedbacks - Admin</title>
      </Head>

      <Box bgcolor="grey.200">
        <Container maxWidth="md">
          <Box pt={8} pb={4}>
            <AdminList />
          </Box>
        </Container>
      </Box>
    </BaseLayout>
  );
}

export default withAdmin(FeedbacksAdminPage);
